module.exports = __webpack_public_path__ + "static/media/gim3.9fd906ba.jpg";